<script setup lang="ts">
import WisionLogo from '../WisionLogo.vue';
import { useAppState } from '../../store/state';
import Button from '../Button.vue';
import { useRouter } from 'vue-router';

const state = useAppState();
const router = useRouter();

const handleOnLogout = () => {
  state.logout();
  router.push({ name: 'start' });
};

const handleOnBack = () => router.push({ name: 'start' });
</script>

<template>
  <div class="flex h-full flex-col items-center w-full px-10 text-onboard-shade2">
    <div class="flex flex-col mt-[20%] items-center">
      <WisionLogo :width="114" class="text-onboard-foreground uppercase"/>
      {{ $t('nfc.noAccess') }}
      <span class="text-xl text-center mt-6 uppercase">
        {{ $t('nfc.changeUser') }}
      </span>
      <div class="text-center mt-4 leading-none">
        <span class="text-sm"></span>
      </div>
    </div>
    <div class="w-40 mt-10 text-center">
      <Button @click="handleOnBack" class="mt-3 h-16 uppercase">
        {{ $t('common.back') }}
      </Button>
      <button v-if="state.hasAccess" @click="handleOnLogout" class="underline mt-2">
        {{ $t('nfc.signout') }}
      </button>
    </div>
    <span class="text-onboard-shade1 pb-3 mt-auto text-center">WISION BUILD {{ state.build }}</span>
  </div>
</template>
